import React, { useEffect, useMemo, useState } from 'react';
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';

const TokenLogoRoot = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'size'
})(({ size }) => ({
  width: size,
  height: size,
  borderRadius: '50%',
  backgroundColor: '#ffffff',
  border: '1px solid rgba(0, 0, 0, 0.08)',
  boxShadow: '0 1px 4px rgba(0, 0, 0, 0.08)',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  overflow: 'hidden',
  flexShrink: 0
}));

const TokenImage = styled('img')({
  width: '100%',
  height: '100%',
  objectFit: 'contain',
  display: 'block'
});

const normalizeTokenUri = (uri) => {
  if (!uri || typeof uri !== 'string') return null;
  const trimmed = uri.trim();
  if (!trimmed) return null;
  if (trimmed.startsWith('ipfs://')) {
    const ipfsPath = trimmed.replace(/^ipfs:\/\//, '').replace(/^ipfs\//, '');
    return `https://ipfs.io/ipfs/${ipfsPath}`;
  }
  if (/^https?:\/\//i.test(trimmed)) {
    return trimmed;
  }
  return null;
};

const TokenLogo = ({ uri, symbol, size = 20 }) => {
  const [hasError, setHasError] = useState(false);
  const normalizedUri = useMemo(() => normalizeTokenUri(uri), [uri]);

  useEffect(() => {
    setHasError(false);
  }, [normalizedUri]);

  const showImage = Boolean(normalizedUri && !hasError);
  const label = symbol ? `${symbol} logo` : 'Token logo';

  return (
    <TokenLogoRoot component="span" size={size} role="img" aria-label={label}>
      {showImage ? (
        <TokenImage
          src={normalizedUri}
          alt={label}
          onError={() => setHasError(true)}
        />
      ) : (
        <AttachMoneyIcon
          sx={{ fontSize: Math.max(size * 0.6, 12), color: '#667eea' }}
        />
      )}
    </TokenLogoRoot>
  );
};

export default TokenLogo;
